module.exports = __webpack_public_path__ + "static/media/slash.75d128db.svg";